import React, { Component } from 'react';
import {
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  InputGroup,
  InputGroupAddon
} from 'reactstrap';
import { connect } from 'react-redux';
import {
  addContentBlock,
  updateContentBlock
} from '../../../store/editStoreActions';
import { bindActionCreators } from 'redux';
import './ContentBlockForm.css';
import update from 'react-addons-update';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { IconPlus, IconRemove } from '../../Icons/Icons';
import 'codemirror/lib/codemirror.css';
import * as CodeMirror from 'codemirror/lib/codemirror';
import 'codemirror/mode/htmlmixed/htmlmixed';

class HtmlEditor extends Component {
  constructor(props) {
    super(props);
    this.textArea = React.createRef();
  }

  componentDidMount() {
    const code = CodeMirror.fromTextArea(this.textArea.current, {
      value: this.props.value,
      lineNumbers: true,
      mode: 'htmlmixed'
    });
    code.on('change', instance => {
      if (this.props.onChange) {
        const value = instance.getDoc().getValue();
        this.props.onChange({
          target: {
            value,
            id: this.props.id
          }
        });
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <Input type="textarea" {...this.props} innerRef={this.textArea} />
      </React.Fragment>
    );
  }
}

class ContentBlockForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: this.props.data || {
        type: ''
      }
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.data.type !== prevState.data.type) {
      this.setState({ data: { type: this.state.data.type } });
    }
  }
  addContentBlock(index, data) {
    this.setState({ data: {} });
    this.props.onClose();
    this.props.addContentBlock(index, data);
  }

  updateContentBlock(sectionIndex, contentBlockIndex, data) {
    if (JSON.stringify(this.props.data) !== JSON.stringify(data)) {
      this.props.updateContentBlock(sectionIndex, contentBlockIndex, data);
    }
    this.props.onClose();
  }

  handleChange(e, id, images) {
    let { value } = e.target;
    let inputId = id;
    if (!inputId) {
      inputId = e.target.id;
    }
    if (e.target.type === 'checkbox') {
      value = e.target.checked;
    }
    if (images) {
      const imageData = this.state.data.images || { sm: '', md: '', lg: '' };
      const newImages = update(imageData, {
        [id]: { $set: value }
      });

      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          images: newImages
        }
      });
    } else {
      this.setState({ data: { ...this.state.data, [inputId]: value } });
    }
  }

  renderTitleInput(title) {
    const { titleFontSize } = this.state.data;
    return (
      <React.Fragment>
        <FormGroup className="flex-50">
          <Label for="title">Title</Label>
          <Input
            id="title"
            onChange={e => this.handleChange(e)}
            value={title || ''}
          />
        </FormGroup>
        <FormGroup className="flex-50">
          <Label for="titleFontSize">Title size</Label>
          <Input
            type="select"
            id="titleFontSize"
            onChange={e => this.handleChange(e)}
            value={titleFontSize || ''}
          >
            <option value="" defaultValue>
              Default
            </option>
            <option value="h1">H1</option>
            <option value="h2">H2</option>
            <option value="h3">H3</option>
            <option value="h4">H4</option>
            <option value="h5">H5</option>
          </Input>
        </FormGroup>
      </React.Fragment>
    );
  }

  renderDescriptionInput(description) {
    return (
      <FormGroup className="flex-100">
        <Label for="description">Description</Label>
        <Input
          id="description"
          onChange={e => this.handleChange(e)}
          value={description || ''}
        />
      </FormGroup>
    );
  }

  renderImageHeader() {
    const { isResponsiveImage, isFullWidthImage, type } = this.state.data;
    return (
      <React.Fragment>
        <FormGroup className="wrapper-line mb-2 text-left">
          <Label check>
            <Input
              onChange={e => this.handleChange(e)}
              id="isResponsiveImage"
              type="checkbox"
              checked={isResponsiveImage || false}
            />
            <small>Responsive images</small>
          </Label>
          {type === 'tile' && (
            <Label check className="ml-3">
              <Input
                onChange={e => this.handleChange(e)}
                id="isFullWidthImage"
                type="checkbox"
                checked={isFullWidthImage || false}
              />
              <small>Full width image</small>
            </Label>
          )}
        </FormGroup>
      </React.Fragment>
    );
  }

  renderImageInput(image) {
    return (
      <FormGroup>
        <Label for="image">
          Image <small>{this.props.imageBasePath}</small>
        </Label>
        <Input
          id="image"
          onChange={e => this.handleChange(e)}
          value={image || ''}
        />
      </FormGroup>
    );
  }

  renderPictureInput(images, fullWidth) {
    return (
      <React.Fragment>
        <FormGroup className={`mb-3 ${fullWidth ? 'flex-100' : ''}`}>
          <Label for="mobile-image">
            Mobile <small>{this.props.imageBasePath}</small>
          </Label>
          <Input
            id={`mobile-image`}
            onChange={e => this.handleChange(e, 'sm', true)}
            value={images['sm'] || ''}
          />
        </FormGroup>
        <FormGroup className={`mb-3 ${fullWidth ? 'flex-100' : ''}`}>
          <Label for="tablet-image">
            Tablet <small>{this.props.imageBasePath}</small>
          </Label>
          <Input
            id={`tablet-image`}
            onChange={e => this.handleChange(e, 'md', true)}
            value={images['md'] || ''}
          />
        </FormGroup>
        <FormGroup className="flex-100">
          <Label for="desktop-image">
            Desktop <small>{this.props.imageBasePath}</small>
          </Label>
          <Input
            id={`desktop-image`}
            onChange={e => this.handleChange(e, 'lg', true)}
            value={images['lg'] || ''}
          />
        </FormGroup>
      </React.Fragment>
    );
  }
  renderLinkInput(link, index) {
    const { data } = this.state;
    const isLinkIndex = typeof index !== 'undefined';
    const { categories } = this.props;
    const optionsArray = [];
    if (categories && categories.length > 0) {
      categories.forEach((item, index) => {
        const parentId = item.id;
        optionsArray.push({ id: `#/${parentId}/` });
        item.subcategories.forEach((subcat, index) => {
          optionsArray.push({ id: `#/${parentId}/${subcat.id}` });
        });
      });
    }
    const typeaheadSettings = {
      disabled: false,
      dropup: false,
      flip: false,
      highlightOnlyResult: false,
      minLength: 0,
      selectHintOnEnter: false,
      clearButton: true
    };
    const linksData = this.state.data.links || [{ text: '', url: '' }];
    return (
      <React.Fragment>
        {isLinkIndex && (
          <FormGroup>
            <Label for="link-text">Link text {index ? index + 1 : ''}</Label>
            <Input
              onChange={e => {
                const newLinks = update(linksData, {
                  [index]: { text: { $set: e.target.value } }
                });

                this.setState({
                  ...this.state,
                  data: {
                    ...this.state.data,
                    links: newLinks
                  }
                });
              }}
              value={link['text'] || ''}
            />
          </FormGroup>
        )}

        <FormGroup>
          <Label
            for="link"
            onClick={() => this.typeahead.getInstance().focus()}
          >
            Link url {index ? index + 1 : ''}
          </Label>

          <InputGroup>
            <Typeahead
              {...typeaheadSettings}
              emptyLabel={''}
              labelKey="id"
              options={optionsArray}
              placeholder="Enter or relative link or search for a category..."
              defaultInputValue={isLinkIndex ? link['url'] || '' : link || ''}
              ref={typeahead => (this.typeahead = typeahead)}
              onChange={selected => {
                if (isLinkIndex) {
                  const newLinks = update(linksData, {
                    [index]: { url: { $set: selected[0].id } }
                  });

                  this.setState({
                    ...this.state,
                    data: {
                      ...this.state.data,
                      links: newLinks
                    }
                  });
                } else {
                  this.setState({
                    data: { ...this.state.data, link: selected[0].id }
                  });
                }
              }}
              onInputChange={selected => {
                if (isLinkIndex) {
                  const newLinks = update(linksData, {
                    [index]: { url: { $set: selected } }
                  });

                  this.setState({
                    ...this.state,
                    data: {
                      ...this.state.data,
                      links: newLinks
                    }
                  });
                } else {
                  this.setState({
                    data: { ...this.state.data, link: selected }
                  });
                }
              }}
              type="search"
            />

            {isLinkIndex && index >= 1 && (
              <InputGroupAddon addonType="append">
                <Button
                  color="danger"
                  onClick={() => {
                    const newLinks = update(linksData, {
                      $splice: [[index, 1]]
                    });

                    this.setState({
                      ...this.state,
                      data: {
                        ...this.state.data,
                        links: newLinks
                      }
                    });
                  }}
                  size="sm"
                  outline
                  title="Remove link"
                >
                  <IconRemove />
                </Button>
              </InputGroupAddon>
            )}
          </InputGroup>
        </FormGroup>
        <FormGroup className="flex-100">
          <Label for="link-tagging">
            Link tagging {index ? index + 1 : ''}
          </Label>
          <Input
            onChange={e => {
              let value = e.target.value;
              if (value.indexOf('?') !== 0) {
                value = '?' + value;
              }
              if (isLinkIndex) {
                const newLinks = update(linksData, {
                  [index]: { tag: { $set: value } }
                });

                this.setState({
                  ...this.state,
                  data: {
                    ...this.state.data,
                    links: newLinks
                  }
                });
              } else {
                this.setState({
                  data: { ...this.state.data, linkTag: value }
                });
              }
            }}
            value={isLinkIndex ? link['tag'] || '' : data.linkTag || ''}
          />
        </FormGroup>
      </React.Fragment>
    );
  }

  renderAddNewLink() {
    const linksData = this.state.data.links || [{ text: '', url: '' }];
    return (
      <FormGroup>
        <Button
          color="primary"
          onClick={() => {
            const newLinks = update(linksData, {
              $push: [{ text: '', url: '' }]
            });

            this.setState({
              ...this.state,
              data: {
                ...this.state.data,
                links: newLinks
              }
            });
          }}
          size="sm"
          outline
          title="Add link"
        >
          <IconPlus /> <span>Add link</span>
        </Button>
      </FormGroup>
    );
  }

  renderButtonInput(buttonText, ctaPosition, ctaMobilePosition) {
    return (
      <React.Fragment>
        <FormGroup className="flex-100">
          <Label for="buttonText">Button text</Label>
          <Input
            id="buttonText"
            onChange={e => this.handleChange(e)}
            value={buttonText || ''}
          />
        </FormGroup>
        {ctaPosition && (
          <FormGroup className="flex-33">
            <Label for="ctaPosition" className="mb-0">
              Content position
            </Label>
            <br />
            <small className="mb-2">
              Includes title, description and button
            </small>
            <Input
              type="select"
              id="ctaPosition"
              onChange={e => this.handleChange(e)}
              value={ctaPosition || ''}
            >
              <option value="right-center" defaultValue>
                Right Center
              </option>
              <option value="left-center">Left Center</option>
              <option value="center-top">Center Top</option>
              <option value="center-bottom">Center Bottom</option>
              <option value="center-center">Center Center</option>
            </Input>
          </FormGroup>
        )}
        {ctaMobilePosition && (
          <FormGroup className="flex-33">
            <Label for="ctaMobilePosition" className="mb-0">
              Content position mobile
            </Label>
            <br />
            <small className="mb-2">
              Includes title, description and button
            </small>
            <Input
              type="select"
              id="ctaMobilePosition"
              onChange={e => this.handleChange(e)}
              value={ctaMobilePosition || ''}
            >
              <option value="right-center-mobile" defaultValue>
                Right Center
              </option>
              <option value="left-center-mobile">Left Center</option>
              <option value="center-top-mobile">Center Top</option>
              <option value="center-bottom-mobile">Center Bottom</option>
              <option value="center-center-mobile">Center Center</option>
            </Input>
          </FormGroup>
        )}
      </React.Fragment>
    );
  }

  renderSkusInput(skus) {
    return (
      <FormGroup className="flex-100">
        <Label for="skus">SKUs</Label>
        <Input
          id="skus"
          onChange={e => {
            e.target.value = e.target.value.toUpperCase().replace(/ /g, '');
            this.handleChange(e);
          }}
          value={skus || ''}
        />
      </FormGroup>
    );
  }

  renderSeparatorInput() {
    const { data } = this.state;
    return (
      <React.Fragment>
        <FormGroup>
          <Label for="separatorSize">Size</Label>
          <Input
            type="select"
            id="separatorSize"
            onChange={e => this.handleChange(e)}
            value={data.separatorSize || ''}
          >
            <option value="small">Small</option>
            <option value="medium" defaultValue>
              Medium
            </option>
            <option value="large">Large</option>
          </Input>
        </FormGroup>
        <FormGroup className="wrapper-line mb-2 text-left">
          <Label check>
            <Input
              onChange={e => this.handleChange(e)}
              id="separatorSolid"
              type="checkbox"
              checked={data.separatorSolid || false}
            />
            <small>Solid line</small>
          </Label>
        </FormGroup>
      </React.Fragment>
    );
  }

  renderHtmlInput() {
    const { data } = this.state;
    return (
      <React.Fragment>
        <FormGroup className="flex-100">
          <Label for="html">HTML</Label>
          <HtmlEditor
            id="html"
            rows="12"
            onChange={e => this.handleChange(e)}
            value={data.html || ''}
          />
        </FormGroup>
      </React.Fragment>
    );
  }

  renderVideoInput() {
    const { data } = this.state;
    return (
      <React.Fragment>
        <FormGroup className="flex-100">
          <Label for="url">Embed url</Label>
          <Input
            id="videoUrl"
            onChange={e => this.handleChange(e)}
            value={data.videoUrl || ''}
          />
        </FormGroup>
        <FormGroup className="wrapper-line mb-2 text-left">
          <Label check>
            <Input
              onChange={e => this.handleChange(e)}
              id="fullscreen"
              type="checkbox"
              checked={data.fullscreen || false}
            />
            <small>Allow fullscreen</small>
          </Label>
          <Label check className="ml-3">
            <Input
              onChange={e => this.handleChange(e)}
              id="autoplay"
              type="checkbox"
              checked={data.autoplay || false}
            />
            <small>Autoplay</small>
          </Label>
        </FormGroup>
      </React.Fragment>
    );
  }

  renderRecommendationsInput() {
    const { data } = this.state;
    return (
      <React.Fragment>
        <FormGroup>
          <Label for="recommendationsType">Type</Label>
          <Input
            type="select"
            id="recommendationsType"
            onChange={e => this.handleChange(e)}
            value={data.recommendationsType || ''}
          >
            <option value="" defaultValue>
              Please select...
            </option>
            <option value="brand">Brand</option>
            <option value="category">Category</option>
          </Input>
        </FormGroup>
        {data.recommendationsType && (
          <FormGroup>
            <Label for="recommendationsValue">
              {data.recommendationsType === 'brand' ? (
                <span>Brand</span>
              ) : (
                <span>Category</span>
              )}
            </Label>
            <Input
              id="recommendationsValue"
              onChange={e => {
                this.handleChange(e);
              }}
              value={data.recommendationsValue || ''}
              placeholder={
                data.recommendationsType === 'brand'
                  ? 'e.g. Acer'
                  : 'e.g. Web_COMPUTER_DESKS'
              }
            />
          </FormGroup>
        )}
        {data.recommendationsType === 'category' && (
          <p className="text-lighter">
            <small>
              The category value can be obtained by referencing
              'ow.state.extCategoryId' from any product details page
            </small>
          </p>
        )}
      </React.Fragment>
    );
  }

  renderFormInput(type) {
    const { data } = this.state;

    switch (type) {
      case 'page-title':
        return (
          <React.Fragment>
            {this.renderTitleInput(data.title)}
            {this.renderDescriptionInput(data.description)}
            {this.renderImageHeader()}
            {data.isResponsiveImage
              ? this.renderPictureInput(
                  data.images || { sm: '', md: '', lg: '' }
                )
              : this.renderImageInput(data.image)}
          </React.Fragment>
        );
      case 'tile':
        return (
          <React.Fragment>
            {this.renderTitleInput(data.title)}
            {this.renderDescriptionInput(data.description)}
            {this.renderLinkInput(data.link)}
            {this.renderImageHeader()}
            {data.isResponsiveImage
              ? this.renderPictureInput(
                  data.images || { sm: '', md: '', lg: '' }
                )
              : this.renderImageInput(data.image)}
            {this.renderButtonInput(data.buttonText)}
          </React.Fragment>
        );
      case 'products':
        return (
          <React.Fragment>{this.renderSkusInput(data.skus)}</React.Fragment>
        );
      case 'shop-the-range':
        const links = data.links || [{ text: '', url: '' }];
        return (
          <React.Fragment>
            {this.renderTitleInput(data.title)}
            {links.map((link, index) => (
              <React.Fragment key={index}>
                {this.renderLinkInput(link, index)}
              </React.Fragment>
            ))}
            {this.renderAddNewLink()}
            {this.renderImageHeader()}
            {data.isResponsiveImage
              ? this.renderPictureInput(
                  data.images || { sm: '', md: '', lg: '' }
                )
              : this.renderImageInput(data.image)}
          </React.Fragment>
        );
      case 'separator':
        return <React.Fragment>{this.renderSeparatorInput()}</React.Fragment>;
      case 'html':
        return <React.Fragment>{this.renderHtmlInput()}</React.Fragment>;
      case 'video':
        return (
          <React.Fragment>
            {this.renderTitleInput(data.title)}
            {this.renderDescriptionInput(data.description)}
            {this.renderVideoInput()}
          </React.Fragment>
        );
      case 'recommendations':
        return (
          <React.Fragment>
            {this.renderRecommendationsInput(data.skus)}
          </React.Fragment>
        );
      case 'collage':
        return (
          <React.Fragment>
            {this.renderTitleInput(data.title)}
            {this.renderDescriptionInput(data.description)}
            {this.renderLinkInput(data.link)}
            {this.renderImageHeader()}
            {data.isResponsiveImage
              ? this.renderPictureInput(
                  data.images || { sm: '', md: '', lg: '' }
                )
              : this.renderImageInput(data.image)}
            {this.renderButtonInput(data.buttonText)}
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
            {this.renderTitleInput(data.title)}
            {this.renderDescriptionInput(data.description)}
            {this.renderLinkInput(data.link)}
            {this.renderImageHeader()}
            {data.isResponsiveImage
              ? this.renderPictureInput(
                  data.images || { sm: '', md: '', lg: '' }
                )
              : this.renderImageInput(data.image)}
            {this.renderButtonInput(
              data.buttonText,
              data.ctaPosition || 'left-center',
              data.ctaMobilePosition || 'left-center-mobile'
            )}
          </React.Fragment>
        );
    }
  }

  render() {
    const { data } = this.state;
    const { onClose, sectionIndex, type, contentBlockIndex } = this.props;

    return (
      <div className="form-wrapper">
        <Form className="flex-form">
          <FormGroup>
            <Label for="type">Type</Label>
            <Input
              type="select"
              id="type"
              onChange={e => this.handleChange(e)}
              value={data.type || ''}
            >
              <option value="" defaultValue>
                Please select...
              </option>
              <option value="banner">Banner</option>
              <option value="html">HTML</option>
              <option value="collage">Collage</option>
              <option value="page-title">Page title</option>
              <option value="products">Products</option>
              <option value="recommendations">Recommendations</option>
              <option value="separator">Separator</option>
              <option value="shop-the-range">Shop the range</option>
              <option value="tile">Tile</option>
              <option value="video">Youtube Video</option>
            </Input>
          </FormGroup>

          {data.type &&
            data.type !== 'separator' &&
            data.type !== 'video' &&
            data.type !== 'products' &&
            data.type !== 'html' &&
            data.type !== 'recommendations' && (
              <FormGroup>
                <Label for="backgroundColour">Background</Label>
                <Input
                  type="select"
                  id="backgroundColour"
                  onChange={e => this.handleChange(e)}
                  value={data.backgroundColour || ''}
                >
                  <option value="" defaultValue>
                    Default
                  </option>
                  <option value="inverse">Dark</option>
                  <option value="transparent">Transparent</option>
                </Input>
              </FormGroup>
            )}

          {data.type && this.renderFormInput(data.type)}
        </Form>
        <div className="form-buttons">
          {type === 'edit' ? (
            <Button
              color="primary"
              onClick={() =>
                this.updateContentBlock(sectionIndex, contentBlockIndex, data)
              }
            >
              Done
            </Button>
          ) : (
            <Button
              color="primary"
              onClick={() => this.addContentBlock(sectionIndex, data)}
              disabled={!data.type}
            >
              Add content block
            </Button>
          )}{' '}
          <Button color="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ stores, activeStore }) => ({
  activeStore: activeStore.activeStore
    ? activeStore[activeStore.activeStore]
    : null,
  activeStoreId: activeStore.activeStore,
  categories:
    activeStore.activeStore && activeStore[activeStore.activeStore]
      ? activeStore[activeStore.activeStore].categories
      : null
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addContentBlock: (sectionId, contentBlock) =>
        addContentBlock(sectionId, contentBlock),
      updateContentBlock: (sectionId, contentBlockId, contentBlock) =>
        updateContentBlock(sectionId, contentBlockId, contentBlock)
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentBlockForm);



// WEBPACK FOOTER //
// ./src/components/landingPage/ContentBlockForm/ContentBlockForm.js